import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configBonusHandle, configGradeList } from '@/api/apis';
export default {
  name: "bonus11",
  props: {
    bonusData: {
      required: true
    }
  },
  watch: {
    bonusData: {
      handler: function handler(newVal, oldVal) {
        this.conditions = JSON.parse(newVal.conditions);
      },
      deep: true,
      // 如果 bonusData 是对象或数组，需要这个
      immediate: false // 是否在初始时立即触发一次

    }
  },
  data: function data() {
    return {
      gradeList: [{
        grade: 0,
        name: "无"
      }, {
        grade: 1,
        name: "店补小v2"
      }, {
        grade: 2,
        name: "店补小v3"
      }, {
        grade: 3,
        name: "店补理事"
      }, {
        grade: 4,
        name: "平级理事"
      }],
      conditions: [// {grade:1,rate:0.03},
        // {grade:2,rate:0.05},
        // {grade:3,rate:0.07},
        // {grade:4,rate:0.02}
      ]
    };
  },
  mounted: function mounted() {},
  methods: {
    clickSave: function clickSave() {
      var _this = this;

      configBonusHandle({
        id: this.bonusData.id,
        conditions: JSON.stringify(this.conditions)
      }).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$alert('保存成功', '提示', {
                  confirmButtonText: '确定'
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }
};